import { render, staticRenderFns } from "./SimpleCardTitle.vue?vue&type=template&id=16ae0132&"
import script from "./SimpleCardTitle.vue?vue&type=script&lang=ts&"
export * from "./SimpleCardTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports